export function shakeElement(
  ref: React.RefObject<HTMLDivElement>,
  params?: Partial<{ duration: number }>
) {
  if (ref.current === null) {
    return;
  }

  const duration = params?.duration ?? 500;
  const prevAnimation = ref.current.style.animation;

  ref.current.style.animation = `shake ${duration}ms ease`;

  setTimeout(() => {
    if (ref.current !== null) {
      ref.current.style.animation = prevAnimation;
    }
  }, duration);
}
